import React from "react";

import IconButton from "@mui/material/IconButton";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function CampanhaMateriaisPrincipais({
  materiaisCampanha,
  alternativasPorMaterial,
  abrirNovoMaterial,
  abrirEditarMaterial,
  pedirEliminarMaterial,
  abrirAlternativas,
  abrirEditarAlternativa,
  apagarAlternativa,
}) {
  return (
    <MDBox
      mt={2}
      p={{ xs: 1.25, md: 2 }}
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        maxWidth: "100%",
        overflowX: "visible",
      }}
    >
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "center" }}
        flexDirection={{ xs: "column", sm: "row" }}
        gap={1}
        mb={2}
        sx={{
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDTypography variant="h6">Materiais principais</MDTypography>

        <MDButton color="success" onClick={abrirNovoMaterial}>
          Novo material
        </MDButton>
      </MDBox>

      <MDBox
        sx={{
          width: "100%",
          overflowX: "auto",
        }}
      >
        <table
          style={{
            width: "100%",
            minWidth: 900,
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Ref.</th>
              <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Material</th>
              <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Qtd</th>
              <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Unid.</th>
              <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Desc. máx. (%)</th>
              <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Obs</th>
              <th style={{ width: 240 }} />
            </tr>
          </thead>

          <tbody>
            {materiaisCampanha.map((m) => {
              const alternativas = [...(alternativasPorMaterial[m.id] || [])].sort(
                (a, b) => Number(b.id || 0) - Number(a.id || 0)
              );

              return (
                <React.Fragment key={m.id}>
                  <tr>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {m.refmaterial}
                    </td>

                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {m.material}
                    </td>

                    <td
                      style={{
                        fontSize: 12,
                        padding: 6,
                        borderTop: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {m.qtd}
                    </td>

                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {m.unidade}
                    </td>

                    <td
                      style={{
                        fontSize: 12,
                        padding: 6,
                        borderTop: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {m.descprommaxfabricante ?? ""}
                    </td>

                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {m.obs}
                    </td>

                    <td
                      style={{
                        borderTop: "1px solid #eee",
                        whiteSpace: "nowrap",
                        position: "sticky",
                        right: 0,
                        background: "#fff",
                        zIndex: 2,
                      }}
                    >
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => abrirEditarMaterial(m)}
                        title="Editar"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => pedirEliminarMaterial(m)}
                        title="Eliminar"
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>

                      <MDButton
                        color="info"
                        size="small"
                        onClick={() => abrirAlternativas(m)}
                        style={{
                          marginLeft: 4,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Nova alt.
                      </MDButton>
                    </td>
                  </tr>

                  {alternativas.map((a) => (
                    <tr key={`alt-${a.id}`}>
                      <td />

                      <td
                        colSpan={4}
                        style={{
                          fontSize: 12,
                          padding: "5px 6px 5px 24px",
                          color: "#6c757d",
                          borderTop: "1px dashed #eee",
                          background: "#fafafa",
                        }}
                      >
                        ↳ {a.refmaterialalternativo} — {a.materialalternativo} | Qtd: {a.qtd}{" "}
                        {a.unidade || ""}| Fator equiv.:{" "}
                        {Number(a.fatorequivalencia || 1)
                          .toFixed(3)
                          .replace(/\.?0+$/, "")}
                        {a.descprommaxfabricante != null && a.descprommaxfabricante !== ""
                          ? ` | Desc. máx.: ${a.descprommaxfabricante}%`
                          : ""}
                        {a.obs ? ` | ${a.obs}` : ""}
                      </td>

                      <td
                        style={{
                          borderTop: "1px dashed #eee",
                          background: "#fafafa",
                          whiteSpace: "nowrap",
                          position: "sticky",
                          right: 0,
                          zIndex: 2,
                        }}
                      >
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => abrirEditarAlternativa(m, a)}
                          title="Editar alternativa"
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => apagarAlternativa(a)}
                          title="Eliminar alternativa"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </MDBox>
    </MDBox>
  );
}
